var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ShopOrderSelectModal',{ref:"shopOrderSelectModal",attrs:{"shop_order":_vm.shop_order},on:{"selectedShopItem":_vm.selectedShopItem}}),_c('memlist-static-table',{ref:"items-table",staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"id":"items-table","fields":_vm.showFields,"items":_vm.items,"head-variant":"light"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }